import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "tools/routerCompat";
import Drawer from "components/Shared/MSidebar/Drawer";
import DrawerHeader from "components/Shared/MSidebar/DrawerHeader";
import DrawerLogo from "components/Shared/MSidebar/DrawerLogo";
import DrawerToggle from "components/Shared/MSidebar/DrawerToggle";
import DrawerMenu from "components/Shared/MSidebar/DrawerMenu";
import DrawerSearch from "components/Shared/MSidebar/DrawerSearch";
import DrawerLink from "components/Shared/MSidebar/DrawerLink";
import DrawerFooter from "components/Shared/MSidebar/DrawerFooter";
import context from "components/Shared/MSidebar/utility/context";
import useSearchFunction from "components/Shared/MSidebar/utility/useSearchFunction";
import { sidebarExpand, sidebarContract, getSidebar } from "actions/layout";

const pathnamesToCloseOn = [
  "/bizops/case-view"
];

const MSidebar = ({
  location: {pathname},
  history,
  dispatch,
  roles,
  open,
  links,
}) => {
  const [searchText, setSearchText] = useState("");
  const searchFunction = useRef(() => {});
  const userExpanded = useRef(false);
  // This is used in the handleResize method as redux state can be stale in the callback
  const isExpanded = useRef(open);

  const isMobile = window.matchMedia("(width <= 767px)").matches;

  useEffect(() => {
      dispatch(getSidebar());
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    },[]
  );

  useEffect(() => {
      if((pathname && pathnamesToCloseOn.includes(pathname)) || isMobile)
      contract();
    },
    [pathname, isMobile]
  );

  useSearchFunction({
    dispatch,
    roles,
    history,
    pathname,
    set: func => searchFunction.current = func,
  });

  const handleResize = () => {
    // This prevents the panel from collapsing immediately after being expanded if the window is small
    if (userExpanded.current) {
      // Reset so it works the next time the window is resized
      userExpanded.current = false;
      return;
    }
    if(isExpanded.current && window.innerWidth < 1200) {
      contract();
    }
  };

  const toggleExpanded = () => open ? contract() : expand();

  const onSearch = () => {
    searchFunction.current(searchText);
  };

  const expand = () => {
    dispatch(sidebarExpand());
    isExpanded.current = true;
    userExpanded.current = true;
  };

  const contract = () => {
    dispatch(sidebarContract());
    isExpanded.current = false;
    userExpanded.current = false;
  };

  if(!links) return null;
  
  return (
    <context.Provider
      value={{
        open,
        searchText,
        toggleSidebar: toggleExpanded,
        openSidebar: () => !open && toggleExpanded(),
        onSearchChange: text => setSearchText(text),
        search: onSearch,
        pathname,
      }}
    >
      <Drawer className="m-sidebar">
        <DrawerHeader>
          <DrawerLogo/>
          <DrawerToggle/>
        </DrawerHeader>
        <DrawerMenu>
          <DrawerSearch/>
          {links.map(({id, ...otherlink}) => (
            <DrawerLink key={id} item={otherlink}/>
          ))}
        </DrawerMenu>
        <DrawerFooter/>
      </Drawer>
    </context.Provider>
  );
};

MSidebar.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  roles: PropTypes.array,
  dispatch: PropTypes.func,
  open: PropTypes.bool,
  links: PropTypes.array,
};

export default withRouter(connect(
  state => ({
    roles: state.user.profile.roles,
    open: state.layout.sidebar.expanded,
    links: state.layout.sidebar.items,
  }),
  dispatch => ({
    dispatch,
  })
)(MSidebar));